import { useState } from 'react';

export const useLoading = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('Carregando...');
    const [loadingStages, setLoadingStages] = useState({
        itens: false,
        pedidoPreparacao: false
    });


    const updateLoadingStage = (stage: keyof typeof loadingStages, status: boolean) => {
        setLoadingStages(prev => ({
            ...prev,
            [stage]: status
        }));
    };

    const calculateLoadingProgress = (stages: typeof loadingStages) => {
        const totalStages = Object.keys(stages).length;
        const completedStages = Object.values(stages).filter(stage => !stage).length;
        return Math.round((completedStages / totalStages) * 100);
    };

    return { updateLoadingStage, isLoading, setIsLoading, loadingMessage, setLoadingMessage, calculateLoadingProgress, loadingStages };
};